import React from 'react';

import styled from 'styled-components';

import HeaderNotifications from './HeaderNotifications';
import HeaderUser from './HeaderUser';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 20px 0px 30px;
  background-color: white;
  gap: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = () => (
  <Container>
    <HeaderNotifications />
    <HeaderUser />
  </Container>
);

export default Header;
